"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isNotString = _interopRequireDefault(require("./helpers/isNotString"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var possessive = function possessive(value) {
  if ((0, _isNotString.default)(value)) {
    return value;
  }
  return value[value.length - 1].toLowerCase() === 's' ? "".concat(value, "'") : "".concat(value, "'s");
};
var _default = exports.default = possessive;